<template>
  <div>
    <span @click="operate('edit', rowData)">编辑</span>
    <span @click="operate('del', rowData)">删除</span>
  </div>
</template>
<script>
export default {
  name: 'delAndEdit',
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    operate(type, rowData) {
      this.$emit('on-custom-comp', { type, rowData })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
span {
  color: $blue;
  cursor: pointer;
  &:nth-child(2) {
    margin-left: 20px;
  }
}
</style>
